import React from 'react';

import component from './component';
import {LogoVkontakte} from './icons';


export default component('Share', {

  getInitialState() {
    return {
      title: null,
      href: null
    }
  },

  componentDidMount() {
    this.setState({
      title: window.document.title,
      href: window.location.href
    })
  },

  render() {
    return (
      <div className="Share">
        <a target="_blank" href={`http://vkontakte.ru/share.php?url=${this.state.href}`} className="Share-Item">
          <LogoVkontakte stroke="#dfe6ee" fill="#4a4a4a" className="Share-Icon" />
        </a>
      </div>
    )
  }

});



// WEBPACK FOOTER //
// ./src/components/Share.js